export default function invoiceTitle() {
    return {
        restrict: 'A',
        require: '^?ngModel',
        scope: {
        },
        link(scope, ele, attr, ngModelController) {
            if (ngModelController) {
                ngModelController.$parsers.push((value) => value.toUpperCase())
            }
            ele.css('text-transform', 'uppercase')
            // ngModelController.$formatters.push(value => value.toUpperCase())
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/invoiceRelated/creditCode.js